import PeopleSaga from "../saga/saga";
import PeopleOperationsSaga from "../saga/people-operations.saga";

export default [PeopleSaga, PeopleOperationsSaga];
